import React from "react";
import { FiUsers } from "react-icons/fi";
import "./styles/OfferCount.css"; // Import your CSS file for styling

interface OfferCountProps {
  count: number;
}

const OfferCount: React.FC<OfferCountProps> = ({ count }) => {
  return (
    <div className="offer-count">
      <FiUsers className="offer-icon" size={12} />
      <span className="offer-text">{`${count} interested`}</span>
    </div>
  );
};

export default OfferCount;
